
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Calculator, ListTodo, FileText, Users, Zap } from "lucide-react";
import { motion } from "framer-motion";

const QuickAccessSection = () => {
  const features = [
    {
      id: "calculator",
      name: "Calculadora Solar",
      icon: <Calculator className="h-5 w-5 text-amber-500" />,
      description: "Calcular instalações",
      path: "/solar/calculadora",
      color: "bg-amber-50 text-amber-700 border-amber-200",
    },
    {
      id: "flow",
      name: "Fluxo Solar",
      icon: <ListTodo className="h-5 w-5 text-blue-500" />,
      description: "Kanban e projetos",
      path: "/solar/fluxo",
      color: "bg-blue-50 text-blue-700 border-blue-200",
    },
    {
      id: "proposals",
      name: "Propostas",
      icon: <FileText className="h-5 w-5 text-purple-500" />,
      description: "Gerenciar propostas",
      path: "/solar/propostas",
      color: "bg-purple-50 text-purple-700 border-purple-200",
    },
    {
      id: "clients",
      name: "Clientes",
      icon: <Users className="h-5 w-5 text-green-500" />,
      description: "Gerenciar clientes",
      path: "/clientes",
      color: "bg-green-50 text-green-700 border-green-200",
    },
    {
      id: "energy",
      name: "Energia",
      icon: <Zap className="h-5 w-5 text-blue-500" />,
      description: "Comercialização",
      path: "/energia",
      color: "bg-blue-50 text-blue-700 border-blue-200",
    }
  ];

  return (
    <Card className="mb-8 bg-gradient-to-br from-gray-50 to-white border-gray-200 shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="text-xl font-semibold">Acessos Rápidos</CardTitle>
        <CardDescription>Seus recursos mais utilizados</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
          {features.map((feature, index) => (
            <motion.div
              key={feature.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              className="cursor-pointer"
            >
              <Link to={feature.path}>
                <Card className={`${feature.color} hover:shadow-md transition-all duration-300 h-full transform hover:-translate-y-1`}>
                  <CardContent className="flex flex-col items-center text-center p-4">
                    <div className="p-2 rounded-full bg-white mb-2 shadow-sm">
                      {feature.icon}
                    </div>
                    <h3 className="font-medium text-sm">{feature.name}</h3>
                    <p className="text-xs opacity-75 mt-1">{feature.description}</p>
                  </CardContent>
                </Card>
              </Link>
            </motion.div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default QuickAccessSection;
